import get from "lodash/get";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import { IS_FOCUS, OPEN_HAMBURGER_MENU } from "../../../store/actions";

export const SearchToggle = () => {
  const isHamburgerMenuOpen = useSelector((state) => get(state, ["isHamburgerMenuOpen"], false));

  const dispatch = useDispatch();

  const toggleHandler = () => {
    dispatch({
      type: OPEN_HAMBURGER_MENU,
      isHamburgerMenuOpen: !isHamburgerMenuOpen,
    });
    dispatch({
      type: IS_FOCUS,
      isFocus: true,
    });
  };

  return (
    <div onClick={toggleHandler} className="search-icon-wrapper">
      <SvgIconHandler className="search-icon" type="search" width="24" height="24" viewBox="0 0 24 24" />
    </div>
  );
};
